import React from 'react';
import styled from 'styled-components';
import { Button, Checkbox, Typography } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined';
import { useTranslation } from 'react-i18next';

const Bar = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding: 10px 16px;
  border-radius: 12px;
  border: 2px solid var(--brand-color-main, #7e4308);
  background: var(--brand-color-light, #fff7e8);
`;

const Spacer = styled.div`
  flex: 1;
`;

interface ProductSelectionBarProps {
  selectedCount: number;
  allOnPageSelected: boolean;
  isBusy?: boolean;
  onToggleSelectAll: () => void;
  onClear: () => void;
  onMove: () => void;
  onDelete: () => void;
}

export default function ProductSelectionBar({
  selectedCount,
  allOnPageSelected,
  isBusy = false,
  onToggleSelectAll,
  onClear,
  onMove,
  onDelete,
}: ProductSelectionBarProps) {
  const { t } = useTranslation('lca');

  return (
    <Bar>
      <Checkbox
        checked={allOnPageSelected}
        indeterminate={!allOnPageSelected && selectedCount > 0}
        onChange={onToggleSelectAll}
        inputProps={{ 'aria-label': t('selection.selectAllOnPage') }}
        sx={{ p: 0 }}
      />
      <Typography variant="subtitle2">
        {t('selection.selected', { count: selectedCount })}
      </Typography>
      <Button variant="text" size="small" onClick={onClear}>
        {t('selection.clear')}
      </Button>

      <Spacer />

      <Button
        variant="secondary"
        size="small"
        onClick={onMove}
        disabled={isBusy || !selectedCount}
      >
        <DriveFileMoveOutlinedIcon fontSize="small" sx={{ mr: '8px' }} />
        {t('selection.move')}
      </Button>
      <Button
        variant="secondary"
        size="small"
        onClick={onDelete}
        disabled={isBusy || !selectedCount}
      >
        <DeleteOutlineIcon fontSize="small" sx={{ mr: '8px' }} />
        {t('selection.delete')}
      </Button>
    </Bar>
  );
}
